import React, { memo } from 'react';
import './_headerTickets.scss';

const HeaderTickets = () => (
  <a
    href='http://www.showshappening.com/'
    rel='noopener noreferrer'
    target='_blank'
    className='menu__bar__tickets'
  >
    <p className='headerTicketsTitle'>TICKETS</p>
    <div className='headerTickets'>
      <div className='headerTicketsIcon' />
    </div>
  </a>
);

export default memo(HeaderTickets);
